import * as React from "react";
import  { useParams } from "react-router-dom";
import { Auth } from "qccat-ui";
import { LoginUrl } from "config/appUrlConfig";
import { authApiService } from "api/authApiService";
import { useAuth } from "AuthContext";

function Authenticate() {
	const params = useParams();
	let auth = useAuth();
	return (
		<>
			<Auth 
				oneTimeToken={params.oneTimeToken}
				storeAuthenticatedUser={auth.signin}
				failedAuthUrl={LoginUrl}
				successAuthRoute="/"
				apiService={authApiService}
			/>
		</>
	)
}

export default Authenticate;